import { type CoinAssetAggregateAsset, type CoinAssetData, type CoinAssetOwnerAsset } from '../../../models/asset/asset-types'
import { type BalanceDataGridRow } from '../../../pages/balance/balance-data-grid'

const DELIMITER = '&&'

export function extractForHeaderInitialExposure (coinAssetData: CoinAssetData): Record<string, string> {
  const results: Record<string, string> = {}
  const coinAssetAggregateAsset: CoinAssetAggregateAsset[] = coinAssetData.aggregate_asset

  if (coinAssetAggregateAsset != null) {
    coinAssetAggregateAsset.forEach(item => { results[item.coin] = item.init_amt })
  }

  return results
}

export function createCoinBalanceRows (coinAssetData: CoinAssetData): BalanceDataGridRow[] {
  const coinAssetAggregateAsset: CoinAssetAggregateAsset[] = coinAssetData.aggregate_asset

  const coinRows = coinAssetAggregateAsset.map(item => {
    return {
      id: item.coin,
      path: [item.coin],
      coin: item.coin,
      account: '',
      account_type: '',
      account_balance: '',
      price_usd: item.price,
      balance_coin: item.amount,
      balance_usd: item.curr_price,
      initial_balance_coin: item.init_amt,
      pnl_coin: item.difference,
      pnl_usd: item.diff_price
    }
  })

  return coinRows
    .concat(createCoinAccountRows(coinAssetData))
    .concat(createCoinAccountTypeRows(coinAssetData))
}

function createCoinAccountRows (coinAssetData: CoinAssetData): BalanceDataGridRow[] {
  const coinAssetOwnerAsset: CoinAssetOwnerAsset[] = coinAssetData.owner_asset

  const accountBalanceSums: Record<string, number> = {}
  const balanceCoinSums: Record<string, number> = {}
  const balanceUsdSums: Record<string, number> = {}
  const initialBalanceCoinSums: Record<string, number> = {}
  const pnlCoinSums: Record<string, number> = {}
  const pnlUsdSums: Record<string, number> = {}

  for (let i = 0; i < coinAssetOwnerAsset.length; i++) {
    const item = coinAssetOwnerAsset[i]
    const { amount, coin, difference, owner } = item
    const currPrice = item.curr_price
    const diffPrice = item.diff_price
    const initAmt = item.init_amt
    const tag = `${String(coin)}${DELIMITER}${String(owner)}`

    if (Number.isFinite(accountBalanceSums[tag])) {
      accountBalanceSums[tag] += Number(amount)
      balanceCoinSums[tag] += Number(amount)
      balanceUsdSums[tag] += Number(currPrice)
      initialBalanceCoinSums[tag] += Number(initAmt)
      pnlCoinSums[tag] += Number(difference)
      pnlUsdSums[tag] += Number(diffPrice)
    } else {
      accountBalanceSums[tag] = Number(amount)
      balanceCoinSums[tag] = Number(amount)
      balanceUsdSums[tag] = Number(currPrice)
      initialBalanceCoinSums[tag] = Number(initAmt)
      pnlCoinSums[tag] = Number(difference)
      pnlUsdSums[tag] = Number(diffPrice)
    }
  }

  return Object.keys(accountBalanceSums).map((key) => {
    const split = key.split(DELIMITER)
    const coin = split[0]
    const owner = split[1]
    return {
      id: `${coin}${DELIMITER}${owner}`,
      path: [coin, owner],
      coin: '',
      account: owner,
      account_type: '',
      account_balance: accountBalanceSums[key].toString(),
      price_usd: '',
      balance_coin: balanceCoinSums[key].toString(),
      balance_usd: balanceUsdSums[key].toString(),
      initial_balance_coin: initialBalanceCoinSums[key].toString(),
      pnl_coin: pnlCoinSums[key].toString(),
      pnl_usd: pnlUsdSums[key].toString()
    }
  })
}

function createCoinAccountTypeRows (coinAssetData: CoinAssetData): BalanceDataGridRow[] {
  const coinAssetOwnerAsset: CoinAssetOwnerAsset[] = coinAssetData.owner_asset

  return coinAssetOwnerAsset.map(item => {
    return {
      id: `${String(item.coin)}${DELIMITER}${String(item.owner)}${DELIMITER}${String(item.account_type)}`,
      path: [item.coin, item.owner, item.account_type],
      coin: '',
      account: '',
      account_type: item.account_type,
      account_balance: item.amount,
      price_usd: '',
      balance_coin: item.amount,
      balance_usd: item.curr_price,
      initial_balance_coin: item.init_amt,
      pnl_coin: item.difference,
      pnl_usd: item.diff_price
    }
  })
}
